import {
  PlanCardHeader,
  PriceContainer,
  CardLabel,
  CardMonthText,
  CardFreetext,
  PriceHeader,
  CardLabelContainer,
  useStyles,
} from './styles';
import { Box, Typography } from '@material-ui/core';
export const PlanCardHeaderV2 = ({ header, cost, secondHeader, hasFreeButton }: any) => {
  const classes = useStyles();
  return (
    <>
      <PlanCardHeader>
        <PriceContainer>
          <PriceHeader hasFreeButton={hasFreeButton}>
            <Typography
              style={{
                fontSize: 16,
                fontWeight: 700,
                textWrap: 'wrap',
                width: '100%',
              }}
            >
              {header}
            </Typography>
            <Box style={{ display: 'flex' }}>
              <Typography style={{ fontSize: 28, fontWeight: 700 }}>$</Typography>
              <Typography style={{ fontSize: 28, fontWeight: 700 }}>{cost}</Typography>
              <Typography
                style={{
                  fontSize: 18,
                  fontWeight: 800,
                  alignSelf: 'end',
                  marginLeft: 5,
                }}
              >
                /
              </Typography>
              <Typography
                style={{
                  fontSize: 12,
                  marginTop: 20,
                  fontWeight: 800,
                }}
              >
                month
              </Typography>
            </Box>
          </PriceHeader>
          {hasFreeButton ? (
            <Box className={classes.invisilbeWidth}>
              <CardLabelContainer>
                <CardLabel>
                  <CardMonthText>6 months</CardMonthText>
                  <CardFreetext>Free*</CardFreetext>
                </CardLabel>
              </CardLabelContainer>
            </Box>
          ) : (
            <Box style={{ alignSelf: 'end' }}>
              <Typography style={{ fontSize: 12, marginTop: -22, fontWeight: 700 }}>{secondHeader}</Typography>
            </Box>
          )}
        </PriceContainer>
      </PlanCardHeader>
    </>
  );
};
